module.exports = __webpack_public_path__ + "img/127.0cffa723.jpg";